import { CSSProperties } from 'react'
import EmptyIcon from '../../../assets/images/empty-page-icon.svg?react'
import Text from '../Text'
import styles from './Empty.module.scss'

const Empty = ({ message, height = '70vh' }: { message: string; height?: string }) => {
  return (
    <div className={styles.root} style={{ '--empty-height': height } as CSSProperties}>
      <EmptyIcon />
      <Text
        variant="bodyLg"
        tone="secondary"
        strong
        casing="none"
        component="h3"
        className={styles.message}
      >
        {message}
      </Text>
    </div>
  )
}

export default Empty
